export const HOME_ROUTE = "/";
export const LOGIN_ROUTE = "/login";
export const FREE_TRIAL_ROUTE = "/register";
export const DASHBOARD_ROUTE = "/dashboard";
export const QICK_APP_URL = "https://app.qickapp.com";
export const QICK_APP_LOGIN_URL = "https://app.qickapp.com/login";
export const QICK_APP_REGISTER_URL = "https://app.qickapp.com/register";
